import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { useToast } from "../../hooks/useToast";

const ActivateTaskModal = ({ show, handleClose, handleActivate }) => {
  const [comment, setComment] = useState("");
  const { showToast, hideToast, toastConfig } = useToast();

  const onActivate = () => {
    if (!comment) {
      showToast("Please enter the reason of retrieval", "error");
      return;
    }
    setComment("");
    handleClose();
    handleActivate(comment);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="modal-customheader">
          <Modal.Title className="custom-modaltitle">Activate Task</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custommodal-body">
          <Form>
            <Form.Group controlId="commentTextarea">
              <Form.Label>Comment </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter comment about reactivating this task..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="custommodal-footer">
          <Button
            variant="secondary"
            className="btn-fontweight  cancelbtn-fontsize"
            onClick={() => {
              setComment("");
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="btn-primary" onClick={onActivate} className="btn-fontweight addbtn-fontsize">
            Activate Task
          </Button>
        </Modal.Footer>
      </Modal>
      <Alert
        show={toastConfig.show}
        variant={toastConfig.type}
        onClose={hideToast}
        dismissible
        className="position-fixed bottom-0 end-0 m-3"
        style={{ zIndex: 1050, minWidth: "300px" }}
      >
        {toastConfig.message}
      </Alert>
    </>
  );
};

export default ActivateTaskModal;
